import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const updateMarkImportant = createAction(ACTION.COMPLAINT_MARK_IMPORTANT.REQUEST, params => ({params}));
export const clearMarkImportant = createAction(ACTION.COMPLAINT_MARK_IMPORTANT_CLEAR, params => ({params}));
